import { render } from "./Informatie.vue?vue&type=template&id=556e4b48&scoped=true"
import script from "./Informatie.vue?vue&type=script&lang=js"
export * from "./Informatie.vue?vue&type=script&lang=js"

import "./Informatie.vue?vue&type=style&index=0&id=556e4b48&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/PhpstormProjects/landgoedmorrenrun/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-556e4b48"]])

export default __exports__